

export default {
    getApprovalDashboardApps: '/api/manageApps/GetApprovalDashboardApps',
    updateApprovalDashboardAppStatus: '/api/manageApps/UpdateApprovalDashboardAppStatus',
    getAppsWithActiveCampaigns: 'getAppsWithActiveCampaigns',
    saveAppsMonthlyBudget: '/api/manageApps/SaveAppsMonthlyBudget',
}



// WEBPACK FOOTER //
// ./src/urls/approveDashboardUrls.js